import {notification} from 'antd';
import {
  getPointsTransactionsUrl,
  getSandos4U,
  getShoppingCartItemsUrl,
  getTransactionDownloadVoucherUrl,
  getTransactionVoucherPdfUrl,
} from '../api/urls';
import {
  LOY3_CLEAR_TRANSACTIONS,
  LOY3_GET_TRANSACTIONS_SUCCESS,
  REGISTER_SANDOS4U
} from '../constants';
import {userConstants} from "../constants/user.constants";
import {userActions as authenticationActions} from "../actions/authenticationActions";

export function getMembershipInfo(authToken, locale, brandId) {
  return dispatch => {
    return fetch(`${getSandos4U}?locale=${locale}&brandId=${brandId || 1}`, {
      headers: new Headers({
        'Content-type': 'application/json',
        'Accept': 'application/json',
        "X-Auth-Token": authToken
      })
    })
    .then(v => authenticationActions.handleResponse(v)(dispatch))
    .then(r => {
      if (r) {
        localStorage.setItem('_loy3MembershipInfo', JSON.stringify(r.responseObj));
        dispatch({ type: REGISTER_SANDOS4U, payload: r })
      }
      return { success: !!r };
    }).catch(() => {
      return { success: false };
    });
  }
}

export function getTransactions(authToken, locale) {
  return dispatch => {
    fetch(`${getPointsTransactionsUrl}?locale=${locale}`, {
      headers: new Headers({
        'Content-type': 'application/json',
        'Accept': 'application/json',
        "X-Auth-Token": authToken
      })
    })
      .then(v => authenticationActions.handleResponse(v)(dispatch))
      .then(r => {
        const transactions = r?.responseObj || [];
        dispatch({ type: LOY3_GET_TRANSACTIONS_SUCCESS, transactions })
      }).catch(() => {
        dispatch({ type: LOY3_CLEAR_TRANSACTIONS, transactions: [] });
      });
  }
}

export function clearTransactions() {
  return (dispatch) => {
    dispatch({ type: LOY3_CLEAR_TRANSACTIONS, transactions: [] });
  }
}

export function loadCart(authToken, brandId, locale) {
  return dispatch => {
    return fetch(`${getShoppingCartItemsUrl}?brandId=${brandId}&locale=${locale}`, {
      headers: new Headers({
        'Content-type': 'application/json',
        'Accept': 'application/json',
        'X-Auth-Token': authToken,
      })
    })
      .then(v => authenticationActions.handleResponse(v)(dispatch))
      .then(r => {
        dispatch({ type: userConstants.LOY3_LOAD_CART_SUCCESS, payload: r.responseObj })
      }).catch(err => {
        dispatch({ type: userConstants.LOY3_LOAD_CART_FAILURE, payload: err })
      })
  }
}

export function downloadTransactionVoucher(authToken, transactionId) {
  const headers = new Headers({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Auth-Token': authToken,
  });
  return (dispatch) => {
    fetch(`${getTransactionDownloadVoucherUrl}?transaction_id=${transactionId}`, { headers })
      .then(v => authenticationActions.handleResponse(v)(dispatch))
      .then(r => {
        const link = document.createElement('a');
        link.href = getTransactionVoucherPdfUrl(r.responseObj);
        link.download = `${transactionId}.pdf`;
        link.target = '_blank';
        link.click();
      })
      .catch(() => {
        notification.error({
            message: 'Error downloading pdf. Please, try again in few minutes.',
        });
      });
  };
}
